<template>
  <div v-if="hasPermission || (config.faceBiometry && userIdentity)">
    <div
      v-if="template"
      class="mb-5 py-5 px-5"
      :style="`
  background-image: linear-gradient(${
    template.faceBiometryGradSecondColor
      ? template.faceBiometryGradSecondColor
      : template.primaryColor
  }, ${template.faceBiometryGradColor ? template.faceBiometryGradColor : '#000'});
  background-color:${template.primaryColor}`"
      style="width: 350px"
    >
      <div v-if="!showCamera">
        <div
          class="mx-auto flex flex-row"
          style="text-align: center; font-size: x-large; color: white"
        >
          <img :src="template.logoUrl" width="50px" style="margin-right: 5px; margin-top: -10px" />
          {{ template.faceBiometryTitle ? template.faceBiometryTitle : '' }}
        </div>
        <div style="margin-top: 30px">
          <p
            :style="`color:${template.secondaryColor}`"
            style="
              text-align: center;
              font-size: 20px;
              color: white;
              text-transform: uppercase;
              font-weight: bold;
              text-align: center;
            "
          >
            {{ strings.title }}
          </p>
        </div>
        <div style="margin-top: 30px">
          <div class="contentInfo" style="text-transform: uppercase">
            {{ template.faceBiometryText ? template.faceBiometryText : '' }}
          </div>
          <br />
          <div class="contentInfo">{{ strings.oneTimeText }}</div>

          <button
            @click="openModal"
            class="btn btn-block text-uppercase btn-black shadow-sm"
            :style="`background-color: ${template.secondaryColor}; color: ${
              template.faceBiometryGradColor ? template.faceBiometryGradColor : '#fff'
            }; font-weight:bold; margin-top:30px`"
          >
            {{ strings.uploadPicText }}
          </button>

          <button
            class="btn btn-block text-uppercase btn-black shadow-sm"
            :style="`color: ${template.secondaryColor}; text-decoration: underline; font-size:12px`"
            @click="finish()"
          >
            {{ strings.uploadLaterText }}
          </button>
        </div>
      </div>

      <div v-else-if="showCamera && !processImageAPICall">
        <div style="margin-top: 10px">
          <p
            :style="`color:${template.secondaryColor}`"
            style="
              text-align: center;
              font-size: 20px;
              color: white;
              text-transform: uppercase;
              font-weight: bold;
            "
          >
            {{ strings.title }}
          </p>
        </div>
        <div v-if="!showPicTakenMsg" class="contentInfo">
          {{ strings.centralizeText }}
        </div>
        <div v-if="showPicTakenMsg" class="contentInfo">
          {{ strings.picTakenText }}
        </div>
        <div v-if="showPicTakenMsg" class="contentInfo">
          {{ strings.picTakenFollowText }}
        </div>
        <Camera @proceed-with-pic="onProceedWithPic" @pic-taken="picTaken" />
        <button
          class="btn btn-block text-uppercase btn-black shadow-sm"
          :style="`color: ${template.secondaryColor}; text-decoration: underline; font-size: 12px;
          `"
          @click="returnFromCamera()"
        >
          {{ strings.backBtnText }}
        </button>
      </div>

      <div
        v-else-if="showCamera && processImageAPICall && imageAPIStatus === -1"
        class="text-center"
      >
        <div style="margin-top: 10px">
          <p
            :style="`color:${template.secondaryColor}`"
            style="
              text-align: center;
              font-size: 20px;
              color: white;
              text-transform: uppercase;
              font-weight: bold;
            "
          >
            {{ strings.title }}
          </p>
        </div>
        <LoadingRing />
      </div>

      <div v-else-if="showCamera && processImageAPICall && imageAPIStatus === 1">
        <div style="margin-top: 10px">
          <p
            :style="`color:${template.secondaryColor}`"
            style="
              text-align: center;
              font-size: 20px;
              color: white;
              text-transform: uppercase;
              font-weight: bold;
            "
          >
            {{ strings.title }}
          </p>
        </div>

        <div
          style="
            text-align: center;
            font-size: 30px;
            text-transform: uppercase;
            color: white;
            font-weight: bold;
          "
        >
          {{ strings.finishThanksText }}
        </div>

        <div class="text-center">
          <i
            class="fa fa-check-circle mx-auto fa-5x"
            :style="`color:${template.secondaryColor}`"
            aria-hidden="true"
          ></i>
        </div>

        <div style="text-align: center; color: white; font-size: 12px; margin-top: 20px">
          {{ strings.finishText1 }}
        </div>

        <div style="text-align: center; color: white; font-size: 12px; margin-top: 20px">
          {{ dinamycTextClient(strings.finishText2) }}
        </div>

        <button
          class="btn text-uppercase btn-block shadow-sm"
          :style="`
         font-weight: 600;
      margin-top:30px;
      background-color: ${template.secondaryColor};
      color: ${template.faceBiometryGradColor};`"
          @click="finish()"
        >
          {{ strings.advanceText }}
        </button>
      </div>

      <div v-else-if="showCamera && processImageAPICall && imageAPIStatus === 0">
        <div style="margin-top: 10px">
          <p
            :style="`color:${template.secondaryColor}`"
            style="
              text-align: center;
              font-size: 20px;
              color: white;
              text-transform: uppercase;
              font-weight: bold;
            "
          >
            {{ strings.title }}
          </p>
        </div>

        <div
          style="
            text-align: center;
            font-size: 30px;
            text-transform: uppercase;
            color: white;
            font-weight: bold;
          "
        >
          {{ strings.finishErrText }}
        </div>

        <div style="text-align: center; color: white; font-size: 12px; margin-top: 20px">
          {{ strings.finishErrText1 }}
        </div>

        <div
          :style="`color:${template.secondaryColor};
      text-align: center;
      margin-top:20px;
      margin-bottom:20px;
      font-weight: 200
      `"
        >
          {{ strings.finishErrText2 }}
        </div>

        <div class="errItemTips">
          <i
            class="fa fa-sun-o mr-2"
            aria-hidden="true"
            :style="`color:${template.secondaryColor}`"
          ></i>
          {{ strings.finishErrText3 }}
        </div>
        <div class="errItemTips">
          <i
            class="fa fa-picture-o mr-2"
            aria-hidden="true"
            :style="`color:${template.secondaryColor}`"
          ></i>
          {{ strings.finishErrText4 }}
        </div>
        <div class="errItemTips">
          <i
            class="fa fa-smile-o mr-2"
            aria-hidden="true"
            :style="`color:${template.secondaryColor}`"
          ></i>
          {{ strings.finishErrText5 }}
        </div>
        <div class="errItemTips">
          <i
            class="fa fa-times mr-2"
            aria-hidden="true"
            :style="`color:${template.secondaryColor}`"
          ></i>
          {{ strings.finishErrText6 }}
        </div>
        <div class="errItemTips">
          <i
            class="fa fa-bullseye mr-2"
            aria-hidden="true"
            :style="`color:${template.secondaryColor}`"
          ></i>
          {{ strings.finishErrText7 }}
        </div>

        <button
          class="btn text-uppercase btn-block shadow-sm"
          :style="`
      font-weight: 600;
      margin-top:30px;
      background-color: ${template.secondaryColor};
      color: ${template.faceBiometryGradColor};`"
          @click="openCamera()"
        >
          {{ strings.captureAgainBtnText }}
        </button>
      </div>

      <!-- Modal -->
      <div class="modal-overlay" v-if="showInfoModal">
        <div class="modalContent">
          <div
            :style="`color:${
              template.faceBiometryGradColor
                ? template.faceBiometryGradColor
                : template.primaryColor
            }`"
            style="
              text-align: center;
              font-size: 20px;
              color: white;
              text-transform: uppercase;
              font-weight: bold;
              text-align: center;
            "
          >
            {{ strings.modalTitle }}
          </div>
          <div style="margin-top: 15px">
            <ul>
              <li class="listItem">{{ strings.listItem1 }}</li>
              <li class="listItem">{{ strings.listItem2 }}</li>
              <li class="listItem">{{ strings.listItem3 }}</li>
              <li class="listItem">{{ strings.listItem4 }}</li>
              <li class="listItem">{{ strings.listItem5 }}</li>
              <li class="listItem">{{ strings.listItem6 }}</li>
            </ul>
          </div>
          <div>
            <button
              class="btn text-uppercase btn-block shadow-sm"
              style="font-size: small; font-weight: 600; letter-spacing: 1px"
              :style="primaryBtnStyle"
              @click="openCamera()"
            >
              {{ strings.advanceText }}
            </button>
            <button
              class="btn text-uppercase btn-block shadow-sm"
              style="
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 1px;
                text-decoration: underline;
              "
              @click="closeModal"
            >
              {{ strings.backBtnText }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadingRing />
    </div>
  </div>
  <div v-else-if="!config.faceBiometry">
    <p style="color: white; font-size: 1.8rem; text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5)">
      Biometria disponível em breve!
    </p>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Camera from '@/components/Camera.vue'
import { loginFB } from '../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'FaceBiometry',
  data: () => ({
    processImageAPICall: false,
    showInfoModal: false,
    showCamera: false,
    image: null,
    showPicTakenMsg: false,
    imageAPIStatus: -1,
    strings: {
      title: 'Biometria Facial',
      imgUrl: 'https://config.fanbase.com.br/images/biometry-face.png',
      oneTimeText: 'VOCÊ PRECISARÁ FAZER O CADASTRO FACIAL APENAS 1 VEZ. VAMOS LÁ?',
      uploadPicText: 'CADASTRAR FOTO',
      uploadLaterText: 'Fazer depois',
      modalTitle: 'ITENS DE ATENÇÃO',
      listItem1:
        'Assegure-se de que a área onde a foto será tirada esteja bem iluminada. Evite sombras fortes no rosto!',
      listItem2:
        'A câmera deve estar posicionada na altura dos seus olhos. Evite fotos tiradas de ângulos muito baixos ou muito altos.',
      listItem3:
        'Escolha um fundo neutro para a sua foto, como uma parede branca. Evite paisagens ou fundos com cores muito vibrantes.',
      listItem4:
        'Evite expressões faciais exageradas, mantenha uma expressão neutra e olhos abertos.',
      listItem5:
        'Remova todos os tipos de acessórios, como óculos escuros, chapéus ou qualquer acessório que cubra o rosto.',
      listItem6: 'Mantenha uma distância de aproximadamente 30 a 50 cm da câmera.',
      centralizeText: 'Centralize seu rosto para a câmera!',
      backBtnText: 'Voltar',
      picTakenText: 'Captura realizada!',
      picTakenFollowText: 'Deseja seguir com essa imagem?',
      advanceText: 'AVANÇAR',
      finishThanksText: 'OBRIGADO!',
      finishText1: 'Reconhecimento facial realizado com sucesso!',
      finishText2: 'A partir de agora você terá mais comodidade e segurança no seu {{ClientId}}.',
      finishErrText: 'oops!',
      finishErrText1:
        'A foto capturada não respeita os itens de boas práticas do registro da biometria facial!',
      finishErrText2: 'LEMBRE-SE: ',
      finishErrText3: 'Procure um ambiente iluminado!',
      finishErrText4: 'Escolha um fundo neutro para a sua foto',
      finishErrText5: 'Evite expressões faciais exageradas',
      finishErrText6: 'Remova todos os tipos de acessórios de sua face',
      finishErrText7: 'Enquadre seu rosto na moldura',
      captureAgainBtnText: 'Capturar Novamente',
    },
  }),
  mounted() {
    if (this.config) {
      this.checkFacialBiometry()
    }
    this.dinamycTextClient()
  },
  computed: {
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle', 'primaryColorText']),
    ...mapState(['template', 'config', 'identity', 'sso']),
    userIdentity() {
      if (this.identity) {
        return this.identity
      }
      const url = window.location.href
      const token = this.getTokenByUrl(url.split('/'))
      const id = this.getIdByToken(token)
      return id
    },
    hasPermission() {
      if (this.config.facePermissions) {
        let cpfList = this.config.facePermissions.map(cpf => cpf.replace(/[.-]/g, ''))
        const url = window.location.href
        const token = this.getTokenByUrl(url.split('/'))
        const CPFuser = this.getCPFByToken(token)
        if (cpfList.includes(CPFuser)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
  },
  components: {
    Camera,
  },
  methods: {
    dinamycTextClient() {
      let client = this.$store.state.config.name.replace(/([a-zA-Z]+)(id)$/i, (match, p1) => {
        return p1.charAt(0).toUpperCase() + p1.slice(1).toLowerCase() + ' ID'
      })
      this.strings.finishText2 = this.strings.finishText2.replaceAll('{{ClientId}}', client)
    },
    async updateFacialBiometryService(form) {
      this.processImageAPICall = true
      await lFB
        .updateFacialBiometry(form)
        .then(res => {
          if (res.header.codigo === 1) {
            this.imageAPIStatus = 1
          } else {
            this.imageAPIStatus = 0
          }
        })
        .catch(err => {
          this.handleError(err)
        })
    },
    async checkFacialBiometryService(identity, ownerId, systemId) {
      await lFB
        .checkFacialBiometry(identity, ownerId, systemId)
        .then(res => {
          this.checkIfHasBiometry(res)
        })
        .catch(err => {
          this.handleError(err)
        })
    },
    getTokenByUrl(url) {
      let lastElement = url[url.length - 1]
      const strTk = '?tk='
      if (lastElement.includes(strTk)) {
        lastElement = lastElement.split(strTk)
        return lastElement[1]
      }
      return null
    },
    getIdByToken(token) {
      if (token) {
        const payloadBase64 = token.split('.')[1]
        const payloadDecoded = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'))
        const payload = JSON.parse(payloadDecoded)
        const id = payload.sub ? payload.sub : payload.identity ? payload.identity : null
        return id
      }
      return null
    },
    getCPFByToken(token) {
      if (token && token.split('.').length === 3) {
        try {
          const payloadBase64 = token.split('.')[1]
          const payloadDecoded = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'))
          const payload = JSON.parse(payloadDecoded)
          const id = payload.userLogin ? payload.userLogin : null
          return id
        } catch (error) {
          console.error('Erro ao decodificar o token:', error)
          return null
        }
      }
      console.warn('Token inválido.')
      return null
    },
    checkFacialBiometry() {
      const id = this.userIdentity ? this.userIdentity : null
      const ownerId = Object(this.config).ownerId ? Object(this.config).ownerId : null
      const systemID = Object(this.config).systemID ? Object(this.config).systemID : null
      if (id && ownerId && systemID) {
        this.checkFacialBiometryService(id, ownerId, systemID)
      }
    },
    checkIfHasBiometry(data) {
      if (data) {
        const hasBiometry = data.temBiometria
        if (hasBiometry) {
          this.finish()
        }
      }
    },
    openModal() {
      this.showInfoModal = true
    },
    closeModal() {
      this.showInfoModal = false
    },
    openCamera() {
      this.showInfoModal = false
      this.showCamera = true
      this.processImageAPICall = false
      this.imageAPIStatus = -1
    },
    onProceedWithPic(value) {
      const payload = {
        Base64: value,
        Identity: parseInt(this.userIdentity),
        OwnerId: parseInt(this.config.ownerId),
        SysId: parseInt(this.config.systemID),
      }
      this.processImageAPICall = true
      this.updateFacialBiometryService(payload)
    },
    picTaken(value) {
      if (value) {
        this.showPicTakenMsg = true
      } else {
        this.showPicTakenMsg = false
      }
    },
    returnFromCamera() {
      this.showCamera = false
    },
    finish() {
      this.$router.push(this.sso ? '/authorize' : '/login')
    },
    handleError(err) {
      this.$bvToast.toast(err, {
        title: `Erro`,
        variant: 'danger',
        solid: true,
      })
    },
  },
}
</script>

<style>
.errItemTips {
  color: white;
  font-size: 10px;
  font-weight: 100;
  margin-top: 10px;
  text-align: left;
}

.contentInfo {
  text-align: center;
  font-size: 12px;
  font-weight: 100;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000aa;
  z-index: 1000;
}

.listItem {
  margin-top: 5px;
  font-weight: 400;
  font-size: 12px;
}

.modalContent {
  width: 340px;
  padding: 2rem;
  background-color: white;
  opacity: 1;
}

@media screen and (min-width: 470px) {
  .modalContent {
    width: 435px;
  }
}

@media screen and (min-width: 767px) {
  .modalContent {
    width: 500px;
  }
}
</style>
